import {
  GET_BOOSTER_PLAN_MIN_AMOUNT,
  GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS,
  GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED,
  GET_ADVANCE_PLAN_MIN_AMOUNT,
  GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS,
  GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED,
  GET_MIXED_FUNDS,
  GET_MIXED_FUNDS_SUCCESS,
  GET_MIXED_FUNDS_FAILED,
  GET_EQUITY_FUNDS,
  GET_EQUITY_FUNDS_SUCCESS,
  GET_EQUITY_FUNDS_FAILED,
  GET_IMMF_FUND,
  GET_IMMF_FUND_SUCCESS,
  GET_IMMF_FUND_FAILED,
} from "./constant";

export const initialState = {
  boosterPlanMinAmount: process.env.REACT_APP_BOOSTER_PLAN_MIN_AMOUNT?.trim(),
  advancePlanMinAmount: process.env.REACT_APP_ADVANCE_PLAN_MIN_AMOUNT?.trim(),
  equityFunds: [],
  mixedFunds: [],
  immfFund: "",
};

export default function planReducer(state = initialState, action) {
  switch (action.type) {
    case GET_IMMF_FUND:
      return {
        ...state,
        immfFundLoading: true,
      };
    case GET_IMMF_FUND_SUCCESS:
      return {
        ...state,
        immfFundLoading: false,
        immfFund: action?.payload?.value?.replace(/['"]/g, ""),
      };
    case GET_IMMF_FUND_FAILED:
      return {
        ...state,
        immfFundLoading: false,
        immfFund: "",
      };
    case GET_MIXED_FUNDS:
      return {
        ...state,
        mixedFundsLoading: true,
      };
    case GET_MIXED_FUNDS_SUCCESS:
      return {
        ...state,
        mixedFundsLoading: false,
        mixedFunds: JSON.parse(
          action?.payload?.value.replace(/\\/g, "") || "[]"
        ),
      };
    case GET_MIXED_FUNDS_FAILED:
      return {
        ...state,
        mixedFundsLoading: false,
        mixedFunds: [],
      };
    case GET_EQUITY_FUNDS:
      return {
        ...state,
        equityFundsLoading: true,
      };
    case GET_EQUITY_FUNDS_SUCCESS:
      return {
        ...state,
        equityFundsLoading: false,
        equityFunds: JSON.parse(
          action?.payload?.value.replace(/\\/g, "") || "[]"
        ),
      };
    case GET_EQUITY_FUNDS_FAILED:
      return {
        ...state,
        equityFundsLoading: false,
        equityFunds: [],
      };
    case GET_BOOSTER_PLAN_MIN_AMOUNT:
      return {
        ...state,
        boosterPlanMinAmountLoading: true,
      };
    case GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS:
      return {
        ...state,
        boosterPlanMinAmountLoading: false,
        boosterPlanMinAmount: action.payload?.value,
      };
    case GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED:
      return {
        ...state,
        boosterPlanMinAmountLoading: false,
        boosterPlanMinAmount: process.env?.REACT_APP_BOOSTER_PLAN_MIN_AMOUNT?.trim(),
      };
    case GET_ADVANCE_PLAN_MIN_AMOUNT:
      return {
        ...state,
        advancePlanMinAmountLoading: true,
      };
    case GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS:
      return {
        ...state,
        advancePlanMinAmountLoading: false,
        advancePlanMinAmount: action.payload?.value,
      };
    case GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED:
      return {
        ...state,
        advancePlanMinAmountLoading: false,
        advancePlanMinAmount: process.env?.REACT_APP_ADVANCE_PLAN_MIN_AMOUNT?.trim(),
      };
    default:
      return state;
  }
}
